/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import State from 'solis/preferences/state';


export const usePreference = (key) =>
{
  return use(State(state => state[key]));
};


export const useBoundPreference = (key, fallback) =>
{
  const dispatch = use(State.Dispatch);

  const value = usePreference(key) ?? fallback;

  const setValue = (value) =>
  {
    dispatch.setPreferences({ [key]: value });
  };

  return [ value, setValue ];
};


export default State;
